import { axios2 } from '@/lib/axiosData';
import { TokenAPIResponse } from '@/types/Chat';

export const getToken = async (): Promise<TokenAPIResponse> => {
  try {
    return await axios2.get('/customer-api/create-token');
  } catch (err) {
    console.error('Error fetching token:', err);
    throw err;
  }
};
